export const FormStatus = Object.freeze({
    "READY": "READY",
    "FAILED": "FAILED",
    "COMPLETED": "COMPLETED"
});